var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgMicrophoneHollow = function SvgMicrophoneHollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12 4.5a3 3 0 10-6 0V9c0 1.4.959 2.576 2.256 2.907A.756.756 0 008.25 12v1.438A4.501 4.501 0 014.5 9 .75.75 0 003 9c0 3.06 2.29 5.585 5.25 5.954v.796a.75.75 0 001.5 0v-.796A6.001 6.001 0 0015 9a.75.75 0 00-1.5 0c0 2.23-1.622 4.08-3.75 4.438V12a.756.756 0 00-.006-.093A3.001 3.001 0 0012 9V4.5zM9 3a1.5 1.5 0 00-1.5 1.5V9a1.5 1.5 0 103 0V4.5A1.5 1.5 0 009 3z"
  })));
};
export default SvgMicrophoneHollow;